// Fichier genere par `yarn svg:components` : ne pas modifier a la main.
// Source : public/images/school/menu/team.svg
import * as React from 'react'
import type { SVGProps } from 'react'
const SvgTeam = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 26" {...props}>
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.282}
      d="M15.5 5.23a3.146 3.146 0 1 0 6.292 0 3.146 3.146 0 0 0-6.291 0M23.364 16.24v-1.573a4.719 4.719 0 0 0-8.847-2.285M2.918 5.23a3.146 3.146 0 1 0 6.291 0 3.146 3.146 0 0 0-6.291 0M1.345 16.24v-1.573a4.719 4.719 0 0 1 8.848-2.285"
    />
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.282}
      d="M9.211 14.663a3.146 3.146 0 1 0 6.292 0 3.146 3.146 0 0 0-6.292 0M17.076 24.1a4.719 4.719 0 0 0-9.438 0"
    />
  </svg>
)
export default SvgTeam
